// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__peTAV","text":"style_text__m26GX"};